<template lang="pug">
.v-main-banner.main-banner(v-if="banner")
	h1(v-if="banner.items && banner.items[0].subtitle" style="position:absolute; z-index: -1; color: transparent;") {{banner.items[0].subtitle}}
	transition(name="fade")
		img.main-banner__background-image(
			v-if="currentSlide && currentSlide.backgroundImage && !isSm"
			:src="currentSlide.backgroundImage"
			alt=""
			:key="currentSlide.text"
		)

		img.main-banner__background-image(
			v-else-if="banner && (banner?.items[0].backgroundImageMob || banner?.items[0].backgroundImage) && isSm"
			:src="banner?.items[0].backgroundImageMob || banner?.items[0].backgroundImage"
			alt=""
		)
	.main-banner__container.container
		.main-banner__wrap
			.main-banner__header
				.main-banner__header-right
					.main-banner__title(v-if="banner.title" v-html="banner.title" )
					v-swiper-slider.main-banner__slider(:options="options"
						swiper-class-name=""
						@swiper="onSwiper"
						@slideChange="slideChange"
					)
						template(v-for="(item, index) in banner.items" :key="index")
							swiper-slide.main-banner__subtitle(v-if="item.subtitle" v-html="item.subtitle" )
			.main-banner__content
				.main-banner__content-left()
					transition(name="fade")
						.main-banner__slogan(v-show="(banner.icon || banner.iconText) && realIndex === 0")
							img.main-banner__icon(v-if="banner.icon" :src="banner.icon" alt="")
							.main-banner__icon-text(v-if="banner.iconText") {{banner.iconText}}
				.main-banner__content-right
					transition(name="fade" mode="out-in" :duration="600")
						.main-banner__text(v-if="currentSlide && currentSlide.text" :key="currentSlide.text" v-html="currentSlide.text" )
					.main-banner__action.flc(v-if="banner.link")
						a.main-banner__link.btn.btn--has-right-icon.btn--primary(:href="banner.link.link" :class="{'btn--wide': isMd}")
							.btn__text {{banner.link.text}}
							.btn__icon-wrap
								v-svg-icon.btn__icon.btn__icon--original(icon="arrow-top-right")
								v-svg-icon.btn__icon.btn__icon--copy(icon="arrow-top-right")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";
import {SwiperSlide} from "swiper/vue";
import VSwiperSlider from "./v-swiper-slider.vue";

export default {
	components: {VSwiperSlider, SwiperSlide},
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			banner: null,
			swiper: null,
			currentSlide: this.banner?.items[0] || null,
			realIndex: 0,
			options: {
				direction: 'vertical',
				slidesPerView: 1,
				allowTouchMove: false,
				height: 'auto',
				speed: 1000,
				loop: true,
				autoplay: {
					delay: 15000,
					reverseDirection: true,
				},
				breakpoints: {
					0: {
						autoplay: {
							delay: 20000000,
						},
					},
					1365: {
						autoplay: {
							delay: 8000,
							reverseDirection: true,
						},
						allowTouchMove: false,
					}
				}
			}
		};
	},

	mounted() {
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	watch: {
		swiper () {
			// console.log('swiper', this.swiper);
		}
	},

	methods: {
		handleScroll() {
			const logoHeight = 80;
			const logoOffset = 48;
			if (window.scrollY > this.$el?.offsetTop - 48 && (window.scrollY < this.$el?.offsetHeight + this.$el?.offsetTop + logoHeight - logoOffset)) {
				document.body.classList.remove('state--page-header-blackout');
			}
		},

		dataSet(data) {
			this.banner = data;
			this.currentSlide = this.banner.items[0];
			this.handleScroll();
			window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		},

		onSwiper(swiper) {
			this.swiper = swiper;
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},

		slideChange(swiper) {
			this.realIndex = swiper.realIndex;
			this.currentSlide = this.banner.items[swiper.realIndex];
		}
	}
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
	/* The active state sets the duration and easing */
	transition: opacity 1s ease-out;
}

.fade-enter-from,
.fade-leave-to {
	/* The starting/ending state sets the initial/final style */
	opacity: 0;
}

.custom-enter-active {
	transition: all 0.6s ease-out;
}

.custom-leave-active {
	transform: translateY(0);
	transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
	transform: translateY(-200px);
}
</style>
